/**
 * tabslider/frontend.js
 * 
 * @author jjarolim
 */

import $ from 'jquery';

const debounce = (func, timeout = 300, callback = undefined) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { 
            func.apply(this, args); 
            if ( callback !== undefined ) {
                callback();
            }
        }, timeout);
    };
}


const detectSingleLineDisplay = ( $tabslider ) => {

    $( '.tabslider__navigation', $tabslider ).each( function() {

        // Detect y position of first li element in page

        const $firstLi = $( 'li:first-child', this )
        const firstLiTop = $firstLi.offset().top

        // Cylcle over all li elements: If one li element has a 
        // different y position, the li elements are displayed in multiple lines

        let isSingleLine = true

        $( 'li', this ).each( function() {
                
            const $li = $( this );
            const liTop = $li.offset().top

            if ( liTop !== firstLiTop ) {
                isSingleLine = false
            }
    
        } );

        if ( isSingleLine ) {
            $tabslider.removeClass( 'is-multi-line' )
            $tabslider.addClass( 'is-single-line' )
        } else {
            $tabslider.removeClass( 'is-single-line' )
            $tabslider.addClass( 'is-multi-line' )
        }

    } );

}


const initializeTabslider = () => {

    // On Document Ready

    $( function() {

        // Each Tabslider

        $( '.block__tabslider' ).each( function() {

            const $tabslider = $( this );

            // Initialize single line detection

            detectSingleLineDisplay( $tabslider );
            $( window ).on( 'resize', debounce( () => detectSingleLineDisplay( $tabslider ), 50 ) );

            // Each Navigation Element

            $( '.tabslider__navigation li', this ).each( function() {

                const $li = $( this );

                // On Click

                $( 'a', $li ).on( 'click', function( e ) {

                    e.preventDefault();

                    // Reset Active Class

                    $( '.tabslider__navigation li', $tabslider ).removeClass( 'active' );
                    $li.addClass( 'active' );

                    
                    // Hide active Panel and fadeIn new Panel

                    const target_id = $( this ).attr( 'href' );

                    $( '.block__tabslider_tab', $tabslider ).removeClass( 'active' ).hide();
                    $( target_id, $tabslider ).addClass( 'active' ).hide().fadeIn( 500 );

                    // XS/SM: Scroll to active panel

                    const $parent = $( this ).closest( '.block__tabslider' );
                    const isSingleLine = $parent.hasClass( 'is-single-line' );

                    if ( ! isSingleLine ) {

                        const scrollTarget = $( target_id ).offset().top - 200;

                        $( 'html, body' ).animate( {
                            scrollTop: scrollTarget
                        }, 500 );

                    }

                } );


            } );



        } );

    } );

}

initializeTabslider();